export var jobs = [
    {
        "id":1,
        "date": "JAN 22 - PRESENT",
        "color": "persistent",
        "company" : "Persistent Systems",
        "link" : "https://www.persistent.com/",
        "designation" : "SDE Intern",
        "description" : "Trained as a core java developer during a 6-month internship."
    },
    
    {
        "id":2,
        "date": "JAN 21 - JUL 21",
        "color" : "inkflix",
        "company" : "Inkflix India",
        "link" : "https://www.inkflix.in/",
        "designation" : "Front-end Developer",
        "description" : "Worked closely with the co-founder of this startup on their react-based official website."
    },
    {
        "id":3,
        "date": "JUL 21 - DEC 21",
        "color" : "lendahand",
        "company" : "Lend-a-Hand India",
        "link" : "https://lendahandindia.org/",
        "designation" : "App Tester",
        "description" : "Worked in a team to test and provide solutions for this NGO's Learning Management System."
    },
    {
        "id":4,
        "date": "AUG 20 - JAN 21",
        "color" : "ufaber",
        "company" : "UFaber Edutech",
        "link" : "https://www.ufaber.com/",
        "designation" : "Content Writing Intern",
        "description" : "Developed content for the grammar-teaching chatbot: FluentLife app."
    },
];